import { soundManager } from '@core/audio/sounds/soundManager'
import { CrossMarkSVG, RightArrowSVG } from '@media/svgs'
import HowToPlay from '../howtoplay/HowToPlay'
import ProvablyFair from '../provablyfair/ProvablyFair'
import MyTransactions from '../transactions/MyTransactions'
import FreebetsMenu from '../freebets/FreebetsMenu'
import TournamentsMenu from '../tournaments/TournamentsMenu'
import TournamentDetail from '../tournaments/TournamentDetail'
import JackpotMenu from '../jackpot/JackpotMenu'
import JackpotDetail from '../jackpot/JackpotDetail'
import JackpotTicketsScreen from '../jackpot/JackpotTicketsScreen'
import JackpotBetTicketsScreen from '../jackpot/JackpotBetTicketsScreen'

const MenuNavigator = ({ stack, onBack, onClose }) => {
  const handleBack = () => {
    soundManager.play('CLICK')
    onBack()
  }
  const handleClose = () => {
    soundManager.play('CLICK')
    onClose()
  }
  const current = stack.at(-1)

  if (!current) return null

  const renderScreen = () => {
    switch (current.screen) {
      case 'MY_BETS':
        return <MyTransactions />

      case 'FREEBETS':
        return <FreebetsMenu />

      case 'TOURNAMENTS':
        return <TournamentsMenu initialTab={current.params?.activeTab} />

      case 'TOURNAMENT_DETAIL':
        return (
          <TournamentDetail
            tournament={current.params?.tournament}
            origin={current.params?.origin}
          />
        )

      case 'JACKPOT':
        return <JackpotMenu initialTab={current.params?.activeTab} />

      case 'JACKPOT_DETAIL':
        return (
          <JackpotDetail jackpot={current.params?.jackpot} viewType={current.params?.viewType} />
        )

      case 'JACKPOT_TICKETS':
        return <JackpotTicketsScreen jackpotId={current.params?.jackpotId} />

      case 'JACKPOT_BET_TICKETS':
        return (
          <JackpotBetTicketsScreen
            contributions={current.params?.contributions}
            betId={current.params?.betId}
          />
        )

      case 'HOW_TO_PLAY':
        return <HowToPlay />

      case 'PROVABLY_FAIR':
        // `roundId` arrives when the player pressed Verify on a specific round,
        // so the screen opens already loaded on it instead of defaulting.
        return <ProvablyFair initialRoundId={current.params?.roundId} />

      default:
        return null
    }
  }

  return (
    <div className="standard-normal-menu-option-content-outer-container standard-normal-fade-in">
      <div className="standard-normal-menu-option-content-inner-container standard-normal-slow-fade-in">
        <div className="standard-normal-menu-option-content-header-container">
          {stack.length > 0 && (
            <div
              className="standard-normal-menu-option-content-go-back-container"
              onClick={handleBack}
            >
              <RightArrowSVG />
            </div>
          )}

          <div className="standard-normal-menu-option-content-title-container">{current.title}</div>

          <div
            className="standard-normal-menu-option-content-close-container"
            onClick={handleClose}
          >
            <CrossMarkSVG />
          </div>
        </div>

        <div className="standard-normal-menu-option-content-body-container">{renderScreen()}</div>
      </div>
    </div>
  )
}

export default MenuNavigator
